import React from 'react';
import { Row, Col } from 'react-styled-flexboxgrid';
import {
  Tile,
  Wrap,
  ErrorDisplay,
  SkeletonLoader,
  Typography,
  Button,
  FooterInfo,
  Icon,
  Notifications,
  Popup,
  Input,
  Select,
  SearchPostCode,
} from '../../components/index';
import { Formik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { useResponsivity } from '../../helpers/helpers';
import { useTranslation } from 'react-i18next';
import * as _ from 'lodash';
import Styled from './PageOverview.style';
import { Tooltip } from 'react-tooltip';
import store from 'store2';
import MeterReadBanner from './MeterReadBanner';
interface PageoverviewProps {
  listLocation: any;
  listLocations: Function;
  deleteLocation: Function;
  editLocation: Function;
  location: any;
  getAddress: Function;
  clearAddress: Function;
  meterRead: any;
  submitMeterRead: Function;
}
export const PageOverview: React.FC<PageoverviewProps> = (props) => {
  const {
    listLocations,
    listLocation,
    deleteLocation,
    editLocation,
    location,
    getAddress,
    clearAddress,
    meterRead,
    submitMeterRead,
  } = props;
  const { error, loading, done } = props.listLocation.status;
  const data = _.get(listLocation, 'data.data');

  const isMobile = useResponsivity();
  const navigate = useNavigate();
  const [t] = useTranslation('common');

  const [popup, setPopup] = React.useState(false);
  const [isId, setId] = React.useState();
  const [content, setContent] = React.useState('');

  const succesAddLocation = _.get(location, 'editLocation.data.message');
  const errorAddLocation = _.get(location, 'editLocation.data.errors');

  const renderErrors = () => {
    return _.map(errorAddLocation, (el, index) => {
      return <li key={index}>{el}</li>;
    });
  };

  React.useEffect(() => {
    listLocations();
  }, [listLocations]);

  const locationNumber = _.get(listLocation, 'data.total');

  const newData =
    data && data.map((v, index) => ({ ...v, position: index + 1 }));

  if (error) {
    return (
      <Wrap>
        <ErrorDisplay />
      </Wrap>
    );
  }
  if (loading && !done) {
    return (
      <Wrap>
        <SkeletonLoader />
      </Wrap>
    );
  }

  const heatedOptions = [
    { value: 'gas', label: 'Gas' },
    { value: 'electric', label: 'Electric' },
    { value: 'coal', label: 'Coal' },
    { value: 'renewable', label: 'Renewable' },
    { value: 'oil', label: 'Oil' },
    { value: "i-don't-know", label: "I don't know" },
  ];
  const findElement = _.find(newData, function (o) {
    return o.id == isId;
  });

  const renderAddressSelect = () => {
    const addresses = _.get(location, 'address.data.data.items');
    if (addresses && addresses === null) {
      return [];
    }

    return (
      addresses &&
      addresses.map((address) => {
        return {
          value: address.summaryline,
          label: address.summaryline,
        };
      })
    );
  };

  const getSpid = _.get(findElement, 'spid');
  const getWholesaler = _.get(findElement, 'wholesaler_id');
  const getMale = _.get(findElement, 'number_of_male_employee');
  const getFemale = _.get(findElement, 'number_of_female_employee');
  const getPupils = _.get(findElement, 'number_of_pupils');
  const getStaff = _.get(findElement, 'number_of_staff');
  const getHeatedWith = _.get(findElement, 'water_heated_with');
  const getName = _.get(findElement, 'property_name');
  const getPostcode = _.get(findElement, 'postcode');
  const getSavedAddress = _.get(findElement, 'address');
  const renderContent = () => {
    if (content === 'delete') {
      return (
        <div style={{ textAlign: 'center' }}>
          <Typography
            size="3"
            text="Are you sure you want to delete your property?"
          />
          <Typography size="p" text="All your data will be lost" />
          <Styled.ButtonWrap>
            <Button
              className="delete-yes"
              onClick={() => {
                deleteLocation(isId);
                setPopup(!popup);
                setTimeout(() => {
                  listLocations();
                }, 1000);
              }}
            >
              Yes
            </Button>{' '}
            <Button>No</Button>
          </Styled.ButtonWrap>
        </div>
      );
    } else if (content === 'edit') {
      return (
        <>
          <Formik
            initialValues={{
              spid: getSpid,
              wholesaler_id: getWholesaler,
              number_of_male_employee: getMale,
              number_of_staff: getStaff,
              number_of_pupils: getPupils,
              number_of_female_employee: getFemale,
              water_heated_with: getHeatedWith,
              property_name: getName,
              postcode: getPostcode,
              address: getSavedAddress,
            }}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(false);
              editLocation(isId, values);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
              /* and other goodies */
            }) => (
              <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                <Row>
                  <Col md={6} sm={12} xs={12}>
                    <SearchPostCode
                      handleBlur={handleBlur}
                      onSearch={() => getAddress(values.postcode)}
                      handleChange={handleChange}
                      setFieldValue={setFieldValue}
                      disabled={false}
                      loading={false}
                      placeholder="Enter your postcode"
                      label="Postcode"
                      value={values.postcode}
                      name="postcode"
                      clearAddress={() => clearAddress()}
                    />
                  </Col>
                  <Col md={6} sm={12} xs={12}>
                    <Select
                      id="address"
                      name="address"
                      value={values.address}
                      type="text"
                      label="Address"
                      placeholder="Address*"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      options={renderAddressSelect()}
                    />
                  </Col>
                  <Col xs={12} sm={12} md={6}>
                    <Input
                      id="property_name"
                      name="property_name"
                      label="Property name"
                      value={values.property_name}
                      type="text"
                      placeholder="Property name*"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        errors.property_name && touched.property_name
                          ? errors.property_name
                          : undefined
                      }
                    />
                  </Col>

                  <Col xs={12} sm={12} md={6}>
                    <Select
                      onChange={handleChange}
                      style={{ marginBottom: '16px' }}
                      onBlur={handleBlur}
                      label="How is the water heated with?"
                      options={heatedOptions}
                      value={values.water_heated_with}
                      name="water_heated_with"
                      placeholder="How is the water heated at your premises?*"
                    />
                  </Col>
                  <Col xs={12} sm={12} md={6}>
                    <Input
                      id="spid"
                      name="spid"
                      value={values.spid}
                      type="text"
                      label="SPID"
                      placeholder="SPID*"
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Col>

                  {getPupils && getStaff ? (
                    <Col xs={12} sm={12} md={6}>
                      <Input
                        id="number_of_pupils"
                        name="number_of_pupils"
                        label="Number of pupils"
                        value={values.number_of_pupils}
                        type="text"
                        placeholder="Number of pupils"
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </Col>
                  ) : (
                    <Col xs={12} sm={12} md={6}>
                      <Input
                        id="number_of_male_employee"
                        name="number_of_male_employee"
                        label="Number of male employees"
                        value={values.number_of_male_employee}
                        type="text"
                        placeholder="Number of male employees"
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </Col>
                  )}
                  {getPupils && getStaff ? (
                    <Col xs={12} sm={12} md={6}>
                      <Input
                        id="number_of_staff"
                        name="number_of_staff"
                        label="Number of staff"
                        value={values.number_of_staff}
                        type="text"
                        placeholder="Number of staff"
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </Col>
                  ) : (
                    <Col xs={12} sm={12} md={6}>
                      <Input
                        id="number_of_female_employee"
                        name="number_of_female_employee"
                        label="Number of female employees"
                        value={values.number_of_female_employee}
                        type="text"
                        placeholder="Number of female employees"
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </Col>
                  )}
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <Button disabled={isSubmitting} type="submit">
                      Update location
                    </Button>
                  </Col>
                  {errorAddLocation ? (
                    <Col md={12} sm={12} xs={12}>
                      <Notifications type="ERROR">
                        {renderErrors()}
                      </Notifications>
                    </Col>
                  ) : null}
                  {succesAddLocation ? (
                    <Col md={12} sm={12} xs={12}>
                      <Notifications type="SUCCESS">
                        {succesAddLocation}
                      </Notifications>
                    </Col>
                  ) : null}
                </Row>
              </form>
            )}
          </Formik>
        </>
      );
    }
  };

  const tableItems = () => {
    return _.map(newData, (el, index) => {
      return (
        <Styled.LocationItem style={{ display: 'flex' }} key={index}>
          <div>
            <Styled.LocationName>{el.property_name}</Styled.LocationName>
            <Styled.LocationPostcode>
              Postcode: {el.postcode}
            </Styled.LocationPostcode>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ marginRight: '8px' }}>{el.rooms.length} room(s)</div>
            {el.rooms.length === 0 ? null : (
              <Button
                appearance="OUTLINED"
                style={{ marginRight: '8px' }}
                onClick={() => {
                  navigate(`/locations/${el.id}`);
                  store('property', el.id);
                }}
              >
                {' '}
                <Icon icon="eye" size={20} style={{ marginRight: '8px' }} />
                view
              </Button>
            )}
            {el.rooms.length >= 10 ? null : (
              <Button
                appearance="REVERSE"
                onClick={() => {
                  navigate(`/${el.id}/add-room`);
                  store('property', el.id);
                }}
              >
                <Icon
                  icon="plus"
                  size={20}
                  colorPrimary="black"
                  style={{ marginRight: '8px' }}
                />{' '}
                add
              </Button>
            )}
          </div>{' '}
          <div style={{ display: 'flex' }}>
            <Button
              data-tooltip-id="edit-tooltip"
              data-tooltip-content="Edit location"
              data-tooltip-place="top"
              className="edit"
              style={{ marginRight: '8px' }}
              onClick={() => {
                setPopup(!popup);
                setId(el.id);
                setContent('edit');
                getAddress(el.postcode);
              }}
              appearance="OUTLINED"
            >
              <Icon icon="pen" size={20} style={{ marginRight: '8px' }} />
              edit
            </Button>
            <Button
              data-tooltip-id="delete-tooltip"
              data-tooltip-content="Delete location"
              data-tooltip-place="top"
              className="delete"
              appearance="OUTLINED"
              onClick={() => {
                setPopup(!popup);
                setId(el.id);
                setContent('delete');
              }}
            >
              <Icon icon="trash" size={20} style={{ marginRight: '8px' }} />
              delete
            </Button>
          </div>
        </Styled.LocationItem>
      );
    });
  };
  const actions = (
    <svg
      width="51"
      height="48"
      viewBox="0 0 51 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 45C40.1503 45 50 35.1503 50 23C50 10.8497 40.1503 1 28 1C15.8497 1 6 10.8497 6 23"
        stroke="#21AAE8"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M28 35C34.6274 35 40 29.6274 40 23C40 16.3726 34.6274 11 28 11C21.3726 11 16 16.3726 16 23"
        stroke="#21AAE8"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M12 26L15.09 32.26L22 33.27L17 38.14L18.18 45.02L12 41.77L5.82 45.02L7 38.14L2 33.27L8.91 32.26L12 26Z"
        stroke="#21AAE8"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  const use = (
    <svg
      width="46"
      height="36"
      viewBox="0 0 46 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1L0.999999 35"
        stroke="#21AAE8"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M12 11.4609L12 34.9994"
        stroke="#21AAE8"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M23 4.48633L23 34.9991"
        stroke="#21AAE8"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M45 23.666L45 34.9993"
        stroke="#21AAE8"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M34 20.1797L34 35.0002"
        stroke="#21AAE8"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );

  const banners = [
    {
      title: 'Business use',
      description:
        'See how your business uses water and what small actions will help save water, energy and money on utility bills.',
      isDesktop: !isMobile,

      onButtonClick: () => {
        navigate('/use');
      },
      buttonText: t('portal.home.myuse_banner_buttonText'),
      icon: use,
    },
    {
      title: 'Easy actions',

      description:
        'Choose simple actions to help your business reduce water use.',
      isDesktop: !isMobile,

      onButtonClick: () => {
        navigate('/easy-actions');
      },
      buttonText: t('portal.home.easywins_banner_buttonText'),
      icon: actions,
    },
  ];
  return (
    <Wrap>
      {locationNumber === 0 ? (
        <Styled.NoLocationBanner>
          <div
            style={{
              marginRight: '64px',
              textAlign: 'center',
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Typography
              style={{ fontSize: '30px', width: '320px', marginBottom: '24px' }}
              size="1"
              text="Get started by adding your location"
            />
            <Button
              onClick={() => navigate('/add-location')}
              style={{ borderRadius: '32px', textTransform: 'none' }}
            >
              Add your location
            </Button>
          </div>
        </Styled.NoLocationBanner>
      ) : (
        <>
          <Row style={{ marginBottom: '16px' }}>
            <Col xs={12} sm={12} md={6}>
              <Typography size="3" text="Location(s)" />
            </Col>
            <Col
              xs={12}
              sm={12}
              md={6}
              style={{ display: 'flex', justifyContent: 'flex-end' }}
            >
              <Button
                className="new-location"
                onClick={() => navigate('/add-location')}
              >
                <Icon
                  icon="plus"
                  size={20}
                  colorPrimary="white"
                  style={{ marginRight: '4px' }}
                />
                New location
              </Button>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={12} md={12}>
              <Row>
                <Col md={12} sm={12} xs={12}>
                  <div>{tableItems()}</div>
                  <Popup
                    isDesktop={!isMobile}
                    open={popup}
                    handleClick={() => {
                      setPopup(!popup);
                      setId(undefined);
                      setContent('');
                    }}
                  >
                    {renderContent()}
                  </Popup>
                </Col>
              </Row>
            </Col>
          </Row>
        </>
      )}
      <Row>
        <Col xs={12} sm={12} md={12}>
          <MeterReadBanner
            listLocation={listLocation}
            location={location}
            meterRead={meterRead}
            submitMeterRead={submitMeterRead}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12} sm={12} md={12}>
          <Styled.LeaderboardBanner>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                marginRight: '3rem',
              }}
            >
              <Typography
                style={{
                  fontSize: '30px',
                  width: '320px',
                  marginBottom: '24px',
                  color: 'white',
                  textAlign: 'center',
                }}
                size="1"
                text="Get started by adding your location"
              />
              <Button
                onClick={() => navigate('/leaderboard')}
                appearance="OUTLINED"
                style={{ borderRadius: '32px', textTransform: 'none' }}
              >
                View leaderboard
              </Button>
            </div>
          </Styled.LeaderboardBanner>
        </Col>
      </Row>
      <Row>
        {banners.map((bannerPoops, index) => {
          return (
            <Col xs={12} sm={12} md={6} key={`key${index}`}>
              <Tile {...bannerPoops} />
            </Col>
          );
        })}
      </Row>
      <Row>
        <Col xs={12} sm={12} md={12}>
          <FooterInfo />
        </Col>
      </Row>
      <Tooltip id="edit-tooltip" />
      <Tooltip id="delete-tooltip" />
    </Wrap>
  );
};

export default PageOverview;
